import React, { useState } from "react";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBase } from "../../../../components/Table/TableBase";
import { useBoolean } from "@fluentui/react-hooks";
import {
  DetailsListLayoutMode,
  IColumn,
  ICommandBarItemProps,
  Icon,
  TooltipHost,
} from "@fluentui/react";
import { IItemIPERC } from "../../../../Interfaces/IIPERC";
import PersonaTag from "../../../../components/elements/Persona";
import IconHelper from "../../../../utils/helpers/iconHelper";
import themeBase from "../../../../utils/theme/themeBase";
import Estado from "../../../../components/elements/Estado";
import { PanelReporteTelerikAdminIperc } from "./PanelReporteTelerikAdminIperc";
import { PanelAdminHistorialFilter } from "./PanelAdminHistorialFilter";
import { useIpercAdmin } from "../../../../hooks/Iperc/useIpercAdmin";
import FotosMantenimiento from "../../../listaVerificacion/FotosMantenimiento";
import PanelAdjuntos from "../PanelAdjuntos";
import { useNavigate } from "react-router-dom";
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent";
import { TableComponent } from "../../../../components/Table/TableComponent";
import { IButtonGroup } from "../../../../Interfaces/filter";

export const AdminHistorialIperc = () => {
  const [
    isOpenPanelReporteTelerik,
    { setTrue: openPanelReporteTelerik, setFalse: dismissPanelReporteTelerik },
  ] = useBoolean(false);
  const [
    isOpenPanelFiltro,
    { setTrue: openPanelFiltro, setFalse: dismissPanelFiltro },
  ] = useBoolean(false);

  const [adjuntoRutas, setAdjuntoRutas] = useState<string[]>([]);

  const navigate = useNavigate();

  const {
    _onChangeChoiceGroup,
    _onSelectDate,
    _onkeyUpSearchTable,
    actualizarTabla,
    dataTable,
    filter,
    isLoading,
    limpiarFiltro,
    onChangeComboBox,
    searchBoxRefTable,
    _getPageSize,
    filterFechas,paginatiom,
    postTableIperAdmin
  } = useIpercAdmin();

  const _columns = [
  //   {
  //     key: "turno",
  //     name: "Turno",
  //     fieldName: "nombre",
  //     minWidth: 100,
  //     maxWidth: 300,  
  // },
    {
      key: "equipo",
      name: "Equipo",
      fieldName: "equipo",
      minWidth: 110,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "actividad",
      name: "Actividad",
      fieldName: "actividad",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "persona",
      name: "Operador",
      fieldName: "persona",
      minWidth: 160,
      maxWidth: 270,
      isResizable: true,
      onRender: (item: IItemIPERC) => (
        <PersonaTag text={item.persona} nroDoi={`DNI : ${item.nroDOI}`} />
      ),
    },
    {
      key: "Guardia",
      name: "Guardia",
      fieldName: "guardia",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "nroDOI",
      name: "DNI Operador",
      fieldName: "nroDOI",
      minWidth: 70,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "supervisor",
      name: "Supervisor",
      fieldName: "supervisor",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      onRender: (item: IItemIPERC) => (
        <PersonaTag
          text={item.supervisor}
          nroDoi={`DNI : ${item.nroDOISupervisor}`}
        />
      ),
    },
    {
      key: "nroDOISupervisor",
      name: "DNI Supervisor",
      fieldName: "nroDOISupervisor",
      minWidth: 70,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "fecha",
      name: "Fecha",
      fieldName: "fechaResgitro",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "fechaValidacion",
      name: "Fecha Revision",
      fieldName: "fechaValidacion",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "estado",
      name: "Estado",
      fieldName: "estado",
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: IItemIPERC) => <Estado value={item.estado} />,
    },
    {
      key: "Firma",
      name: "Firmas",
      fieldName: "Firma",
      minWidth: 50,
      maxWidth: 120,
      isResizable: true,
      onRender: (item: IItemIPERC) => (
        <>
          {item.rutaFirma && (
            <TooltipHost content={"Operador"}>
              <Icon
                iconName="PDF"
                className={themeBase.classNamesIcon.iconFont}
                style={{ cursor: "pointer", color: "red" }}
                // onClick={(arg) => window.open(item.rutaFirma, "_blank")}
                onClick={() => {
                  if (item.rutaFirma) {
                    setAdjuntoRutas([item.rutaFirma]);
                  }
                  openAdjuntoIperc();
                }}
              />
            </TooltipHost>
          )}
          {item.rutasPDF !== undefined && item.rutasPDF.length > 0 && (
            <TooltipHost content={"Supervisor"}>
              <Icon
                iconName="PDF"
                className={themeBase.classNamesIcon.iconFont}
                style={{ cursor: "pointer", color: "red" }}
                // onClick={(arg) => window.open(item.rutasPDF[0], "_blank")}
                onClick={() => {
                  if (item.rutasPDF[0]) {
                    setAdjuntoRutas([item.rutasPDF[0]]);
                  }
                  openAdjuntoIperc();
                }}
              />
            </TooltipHost>
          )}
        </>
      ),
    },
  ];
  const buttonLeft: IButtonGroup[] = [
    {
      onClick: ()=>{
        actualizarTabla();
      },
      text: "Actualizar",
    },
    {
      onClick: () => {
        limpiarFiltro();
      },
      text: "Limpiar Filtro",
    },
  ];
  const _CommandLeftItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        actualizarTabla();
      },
    },
    // {
    //   ...IconHelper.ICON_BS_FILTER,
    //   text: "Limpiar Filtro",
    //   onClick: () => {
    //     limpiarFiltro();
    //   },
    // },
  ];
  const _farItems: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_EXCEL,
      onClick: () => {
        navigate(`reporteGeneral`);
        // openPanelReporteTelerik();
      },
    },
    {
      ...IconHelper.ICON_FILTER,
      text: "Buscar",
      onClick: () => {
        openPanelFiltro();
      },
    },
  ];
  
  const [
    isOpenAdjuntoIperc,
    { setTrue: openAdjuntoIperc, setFalse: dismissAdjuntoIperc },
  ] = useBoolean(false);

  return (
    <div>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <CabeceraTable
            SubTitulo="Gestión General de Historial de IPERCs "
            Titulo="Histórico de IPERCs"
            placeholder="Buscar operador..."
            componentRef={searchBoxRefTable}
            onKeyUp={_onkeyUpSearchTable}
          />
        </div>
      </div>
      <br />
     
      <TableBaseComponent 
       leftBar={_CommandLeftItems}
       rigthBar={_farItems}
       data={dataTable}
       column={_columns}
       isLoading={isLoading}
       pagination={paginatiom}
       getPageSize={_getPageSize}
       layout={DetailsListLayoutMode.justified}
       />
      <PanelReporteTelerikAdminIperc
        isOpen={isOpenPanelReporteTelerik}
        onDismiss={dismissPanelReporteTelerik}
      />
      <PanelAdminHistorialFilter
        isOpen={isOpenPanelFiltro}
        onDismiss={dismissPanelFiltro}
        fechasFilter={filterFechas}
        filter={filter}
        limpiarFiltro={limpiarFiltro}
        onChangeChoiceGroup={_onChangeChoiceGroup}
        onChangeComboBox={onChangeComboBox}
        onSelectDate={_onSelectDate}
        buscar={postTableIperAdmin}
      />
      {/* PANEL FOTOS */}
      <PanelAdjuntos
        urlAdjunto={adjuntoRutas}
        isOpen={isOpenAdjuntoIperc}
        dismiss={dismissAdjuntoIperc}
      />
    </div>
  );
};
